import React from "react";
import { Grid, Row, Col } from 'react-flexbox-grid';
import cn from 'classnames';
import * as Icon from '../../../components/Icons';
import styles from './styles.module.css';
import { Button } from "../../../components";

const RoomChoices = (props) => {
	return (
		<Grid fluid className={styles.reset} >
			<Row>
				<Col sm={12}>
					<div className={styles.borderBottom} ref={props.refProp}>
						<span className={styles.title}>Room Choices</span>
					</div>
					<div className={cn([styles.flexContainer])}>
						<p className={styles.grayText}>Show Only Rooms With</p>
						<p className={styles.grayText}>Breakfast Included</p>
						<p className={styles.grayText}>Free Cancellation</p>
					</div>
					<div>
						<table className={styles.table}>
							<thead>
								<tr className={styles.headers}>
									<th>Room Type</th>
									<th>People</th>
									<th>Rooms</th>
									<th>Total Price</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td style={{ textTransform: 'capitalize' }}><Icon.SingleBed /> Single</td>
									<td><Icon.OnePerson/> <Icon.OnePerson/></td>
									<td>2</td>
									<td>
										<div className={styles.prices}>
											<p className={styles.price}>Sar 576</p>
											<p>Total for 1 night</p>
											<Button >Book Now</Button>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</Col>
			</Row>
			<Row>
				<Col lg={12}>
					<div className={styles.borderBottom} ref={props.refProp}>
						<span className={styles.title}>Hotel Policy</span>
					</div>
					<div className={styles.policyText}>
						Local laws may restrict unmarried guests from sharing room. Couples are required to provide proof of marriage if they wish to share a room or if requested by the hotel. Alcohol is not served or permitted on this property.
						You must present a photo ID when checking in. Bed type and smoking preferences are subject to availability. Your reservation is prepaid. The total charge includes all room charges and taxes, as well as fees for access and booking. Any incidental charges such as parking, phone calls, and room service will be handled directly between you and the property.
						Please note that certain municipalities in some cities in a few countries also levy local taxes on the service provided. These taxes cannot be collected in advance and have to be borne directly by the customers and should be paid during the checkout from the hotel.
					</div>
				</Col>
			</Row>
		</Grid>
	)
};
export default RoomChoices
